<template>
  <ALink
    v-editable="blok"
    :to="blok.link"
    class="block relative w-full h-full effect-hover-tilt group"
    ref="cardRef"
    :style="{
      '--rotate-x': `${tilt.x}deg`,
      '--rotate-y': `${tilt.y}deg`,
    }">
    <div
      class="w-full h-full pb-[--aspect] mask"
      :style="{
        '--aspect': `${maskAspect * 100}%`,
      }">
      <div
        class="absolute top-50% left-50% translate-[-50%] w-full h-full effect-hover-tilt-media">
        <ElementMedia
          class="w-full h-full object-cover"
          :bloks="blok.media"
          :ratio="{
            w: maskWidth,
            h: maskHeight,
          }"
          :sizes="sizes" />
      </div>
      <ElementSpotlightCardText
        :blok="blok"
        :layout="layout"
        :tintOpacity="tintOpacity"
        class="absolute top-50% left-50% translate-[-50%] w-full h-full" />
    </div>
  </ALink>
</template>

<script setup lang="ts">
import {
  ElementSpotlightCardStoryblok,
  ModuleSpotlightStoryblok,
} from "@/types";
import { ImgSizes } from "@/components/atoms/AImage.vue";
import useHoverTilt from "@/composables/useHoverTilt";

interface Props {
  blok: ElementSpotlightCardStoryblok;
  index: number;
  total: number;
  sizes: ImgSizes;
  layout: ModuleSpotlightStoryblok["layout"];
  tintOpacity?: number;
}
defineProps<Props>();

const maskWidth = 387;
const maskHeight = 445;
const maskAspect = maskHeight / maskWidth;

const cardRef = ref<HTMLElement | null>(null);
const { tilt } = useHoverTilt(cardRef);
</script>

<style lang="scss" scoped>
.mask {
  -webkit-mask-image: url("@/assets/masks/spotlight-card-mask.svg");
  mask-image: url("@/assets/masks/spotlight-card-mask.svg");
  -webkit-mask-size: contain;
  mask-size: contain;
}
</style>
